import React from 'react';
import {
  Container,
  SecondWrapper,
  BlocWrapper,
} from 'containers/AsiDetailsPage/ServicesBlock/styles';
import ServicesBloc from 'containers/ASIDashboard/services/index';

const ServicesBlock = () => {
  return (
    <BlocWrapper height="135px">
      <Container padding={3}>
        <SecondWrapper container>
          <ServicesBloc mdGrid={12} smGrid={12} />
        </SecondWrapper>
      </Container>
    </BlocWrapper>
  );
};
export default ServicesBlock;
